import type { Dayjs } from "dayjs";
import { createContext } from "react";
import {
  AuthState,
  LoginCredentials,
  AuthRequestOptions,
  ForgotPasswordCredentials,
  ResetPasswordCodeCredentials,
  ResetPasswordCredentials,
  IUser,
} from "./auth";
interface AuthContextType extends AuthState {
  login: (credentials: LoginCredentials) => Promise<void>;
  logout: () => Promise<void>;
  refreshToken: () => Promise<string | null>;
  forgotPassword: (
    credentials: ForgotPasswordCredentials,
    options?: AuthRequestOptions,
  ) => Promise<void>;
  openResetCodeEntry: (email: string) => void;
  getResetCodeResendAvailableAt: (email: string | null) => Dayjs | null;
  resetPasswordCode: (
    credentials: ResetPasswordCodeCredentials,
  ) => Promise<void>;
  verifyResetPasswordCode: (
    credentials: ResetPasswordCodeCredentials,
    options?: AuthRequestOptions,
  ) => Promise<void>;
  resetPassword: (credentials: ResetPasswordCredentials) => Promise<void>;
  handleImpersonationChange: (state: {
    isImpersonating: boolean;
    impersonatedUser: IUser | null;
  }) => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export default AuthContext;
